/* eslint-disable react/no-unescaped-entities */
import { Meta } from '@/layout/Meta'
import { Main } from '@/templates/Main'
import { AppConfig } from '@/utils/AppConfig'
import Link from 'next/link'
import { note } from '@/utils/Note'
import { useEffect } from 'react'
import { useRouter } from 'next/router'

const Blog = () => {
  const router = useRouter()

  useEffect(() => {
    note('Visited Blog Home')
  }, [])
  
  
  return (
    <Main meta={<Meta 
        title="The Secret Sauce"
        description="The source code (for free)" />}>
      <h2 className="text-4xl font-bold text-sky-700">The Secret Sauce</h2>
      <div className="flex flex-col md:flex-row">

      <div>
        There is such a thing as a free lunch!<br/><br/>  Below are some tutorials
        for the DIY professionals out there.
        <p className='italic text-md mt-1'>Make sure to check back regularly for new tutorials.</p>
        <ul className="list-disc list-inside">
          <li>
            <Link href="/blog/how-to-integrate-with-bing-ads">
              Bing Ads
            </Link>
          </li>
          <li>
            <Link href="/blog/how-to-integrate-with-google-ads-api">
              Google Ads API
            </Link>
          </li>
          <li>
            <Link href="/blog/how-to-integrate-commission-junction-publisher">
              Commission Junction Publisher
            </Link>
          </li>
          <li>
            <Link href="/blog/how-to-integrate-with-tiktok-ads">
              TikTok Ads
            </Link>
          </li>
        </ul>
      </div>
        <img 
          src={`${router.basePath}/assets/images/heros/baker-serving-dessert4.jpeg`}
          className="h-72 mx-6 opacity-90 rounded-lg"
        />
      </div>
    </Main>
  )
}

export default Blog
